module.exports = __webpack_public_path__ + "img/category_205.80df3592.jpg";